// Maps constants
export const MAP_HEIGHT = '480px';
